<!-- 考试界面 -->
<template>
  <div class="frame">
    <el-backtop
      title="回到顶部"
      :visibility-height="400"
      :right="70"
      :bottom="53"
    ></el-backtop>
    <div class="top">
      <div class="title">{{ paper.paperTitle }}</div>
    </div>
    <div class="wrap">
      <div class="left">
        <el-statistic
          @finish="countFinish"
          format="HH:mm:ss"
          :value="dealine"
          title="剩余时间"
          :time-indices="!!dealine"
        >
        </el-statistic>
        <div class="select-list">
          <div
            :class="{ 'select-item': true, select: item.choice != '' }"
            v-for="item in sigleList"
            :key="item.id"
            @click="switchToQuestion(item.order)"
          ></div>
          <div
            :class="{ 'select-item': true, select: item.choice != '' }"
            v-for="item in mutipleList"
            :key="item.id"
            @click="switchToQuestion(item.order)"
          ></div>
          <div
            :class="{ 'select-item': true, select: item.choice != '' }"
            v-for="item in judgeList"
            :key="item.id"
            @click="switchToQuestion(item.order)"
          ></div>
        </div>
        <div class="menus">
          <div class="btn" @click="handInPaper">
            <i class="el-icon-s-claim"></i>
            <span>交卷</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="questiones">
          <div class="question" v-for="item in sigleList" :key="item.id">
            <div class="title">
              <el-tag type="success" size="small">单选题</el-tag>
              <span class="name">
                {{ item.order }}、{{ item.questionTitle }}
              </span>
              <span class="choice">{{ item.choice }}</span>
            </div>
            <div class="content">
              <el-radio-group class="group" v-model="item.choice">
                <div
                  class="option"
                  v-for="option in item.questionChoose"
                  :key="option.label"
                >
                  <el-radio :label="option.value">{{ option.label }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div class="question" v-for="item in mutipleList" :key="item.id">
            <div class="title">
              <el-tag size="small">多选题</el-tag>
              <span class="name">
                {{ item.order }}、{{ item.questionTitle }}
              </span>
              <span class="choice">{{ item.choice.join("") }}</span>
            </div>
            <div class="content">
              <el-checkbox-group class="group" v-model="item.choice">
                <div
                  class="option"
                  v-for="option in item.questionChoose"
                  :key="option.label"
                >
                  <el-checkbox :label="option.value">{{
                    option.label
                  }}</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="question" v-for="item in judgeList" :key="item.id">
            <div class="title">
              <el-tag type="warning" size="small">判断题</el-tag>
              <span class="name">
                {{ item.order }}、{{ item.questionTitle }}
              </span>
              <span class="choice">{{ item.choice }}</span>
            </div>
            <div class="content">
              <el-radio-group class="group" v-model="item.choice">
                <div
                  class="option"
                  v-for="option in item.questionChoose"
                  :key="option.label"
                >
                  <el-radio :label="option.value">{{ option.label }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../layout/components/foot.vue";
export default {
  components: { Footer },
  data() {
    return {
      paper: {},
      resultObj: {}, // 考试结果对象
      dealine: 0, // 倒计时结束时间
      sigleList: [], // 单选题
      mutipleList: [], // 多选题
      judgeList: [], // 判断题
      loading: false,
    };
  },
  created() {
    // 获取试卷详情
    this.$api.getPaperById({ id: this.$route.params.id }).then((res) => {
      if (res.code == 0) {
        this.paper = res.data;

        this.$api
          .setStartTime({ paperId: this.$route.params.id })
          .then((res) => {
            if (res.code != 0) {
              this.$router.replace("/");
              return;
            }
            this.resultObj = res.data;
            const now = new Date(res.data.examinationStartTime);
            this.dealine = Number(now) + (this.paper.testDuration || 0) * 1000;
          });
      }
    });
    // 获取所有试题
    this.$api
      .getPaperQuestionById({ id: this.$route.params.id })
      .then((res) => {
        if (res.code == 0) {
          let sort = 1; // 初始排序
          this.sigleList = res.data.danxuanList.map((ele) => {
            ele.order = sort++;
            ele.choice = ""; // 用户的选择
            ele.questionChoose = JSON.parse(ele.questionChoose);
            return ele;
          });
          this.mutipleList = res.data.duoxuanList.map((ele) => {
            ele.order = sort++;
            ele.choice = []; // 用户的选择
            ele.questionChoose = JSON.parse(ele.questionChoose);
            return ele;
          });
          this.judgeList = res.data.panduanList.map((ele) => {
            ele.order = sort++;
            ele.choice = ""; // 用户的选择
            ele.questionChoose = JSON.parse(ele.questionChoose);
            return ele;
          });
        }
      });
  },
  mounted() {
    window.addEventListener("beforeunload", this.beforeunloadFunc);
  },
  methods: {
    beforeunloadFunc(e) {
      let vm = this;
      const allQuestion = [...vm.sigleList, ...vm.mutipleList, ...vm.judgeList];
      let filterArr = allQuestion.filter((ele) => ele.choice);
      if (filterArr.length != 0) {
        // 考试后防止误触重载页面导致内容丢失
        e.preventDefault();
        e.returnValue = "提醒重载";
      }
    },
    // 跳转到对应题目
    switchToQuestion(order) {
      let doms = document.getElementsByClassName("question");
      window.scrollTo({ top: doms[order - 1].offsetTop });
    },
    handInPaper() {
      let { sigleList, mutipleList, judgeList } = this;
      // 所有题目
      const allLen = sigleList.length + mutipleList.length + judgeList.length;
      // 已答题目
      const answerSigle = sigleList.filter((ele) => ele.choice);
      const answerMutiple = mutipleList.filter((ele) => ele.choice);
      const answerJudge = judgeList.filter((ele) => ele.choice);
      const answerLen =
        answerSigle.length + answerMutiple.length + answerJudge.length;
      this.$confirm(
        `共有${allLen}道题目，已填写${answerLen}道，确认交卷？`,
        "交卷",
        {
          type: "warning",
          confirmButtonText: "确认交卷",
          cancelButtonText: "再检查一下",
        }
      )
        .then(() => {
          this.submit();
        })
        .catch(() => {});
    },
    // 倒计时结束
    countFinish() {
      this.submit();
    },
    submit() {
      localStorage.removeItem("startTime");
      const allQuestion = [
        ...this.sigleList,
        ...this.mutipleList,
        ...this.judgeList,
      ];
      const params = {
        examinationQuestionResultDtos: allQuestion.map((ele) => ({
          paperQuestionId: ele.id,
          userChooseResult:
            ele.questionType == 1 ? ele.choice.join(",") : ele.choice,
        })),
        examinationResultId: this.resultObj.id,
        paperId: this.paper.id,
      };
      const loading = this.$loading({
        lock: true,
        text: "正在评分...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$api
        .submitTestPaper(params)
        .then((res) => {
          if (res.code == 0) {
            this.$router.replace("/testResult/" + this.resultObj.id);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeunloadFunc);
  },
};
</script>

<style lang="scss" scoped>
.option ::v-deep {
  .el-radio__input.is-checked + .el-radio__label,
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #409eff;
  }
  .el-radio__input.is-checked .el-radio__inner,
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #409eff;
    background: #409eff;
  }
}
.el-tag {
  color: #409eff;
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
}
.frame {
  background-color: #f9f9f9;
}
.top {
  width: 100%;
  height: 200px;
  background-color: #409eff;
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - 30px),
    calc(50% + 370px) 100%,
    47% calc(100% - 27px),
    calc(50% - 370px) 100%,
    0 calc(100% - 30px)
  );
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  .back-box {
    width: 1200px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;

    .back {
      color: #fff;
      font-size: 20px;
      cursor: pointer;

      &:hover {
        color: $theme;
      }
    }
  }

  .title {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .desc {
    font-size: 18px;
  }
}

.wrap {
  display: flex;
  align-items: flex-start;
  width: 1200px;
  margin: 20px auto 0;
  padding-bottom: 40px;

  .left {
    width: 380px;
    margin-right: 20px;
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
    position: sticky;
    top: 20px;
    box-shadow: 0 0 5px #eee;

    .title {
      font-size: 20px;
    }

    .select-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;

      .select-item {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        border: 1px solid #999;
        margin: 0 5px 10px;
        cursor: pointer;
      }
      .select {
        background-color: #409eff;
        border-color: #409eff;
      }
    }
    .menus {
      margin-top: 20px;
      display: flex;
      justify-content: center;

      .btn {
        width: fit-content;
        background-color: #409eff;
        color: #fff;
        font-weight: 500;
        padding: 8px 20px;
        font-size: 14px;
        border-radius: 4px;
        user-select: none;

        &:hover {
          cursor: pointer;
          background-color: #66b1ff;
        }
        & + .btn {
          margin-left: 10px;
        }

        i {
          margin-right: 5px;
          font-size: 16px;
        }
      }
    }
  }
  .right {
    width: 800px;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0 0 5px #eee;

    .questiones {
      border: 1px solid #dedede;

      .question {
        padding: 10px;

        &:last-child {
          .content {
            border-bottom: none;
          }
        }

        .title {
          .name {
            margin-left: 10px;
            vertical-align: middle;
          }
          .choice {
            margin-left: 10px;
            color: #409eff;
            vertical-align: middle;
          }
        }
        .content {
          padding: 30px 10px 20px;
          border-bottom: 1px solid #dedede;

          .group {
            display: flex;
            flex-wrap: wrap;

            .option {
              min-width: 50%;
              line-height: 28px;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
